/**
 * @file step
 * @author zhaomiaoyuan
 */
import React, {useState, useEffect} from 'react';
import {withRouter} from 'react-router';
import PropTypes from 'prop-types';
// import Modal from 'antd/lib/modal';
import UploadProof from '../../components/UploadProof/index.tsx';
import InputFormItem from '../../components/InputFormItem/index.tsx';
import SendCode from '../../components/SendCode/index.tsx';
// import AgreeProtocol from '../../components/AgreeProtocol/index.tsx';
import {
    certTip
} from '../../components/UploadProof/uploadTip.tsx';
import {recordProxy, bCat_2055_request} from '../../util';
// import {appealTypeEventTracking} from './conf';
import geren1 from '../../asset/img/appeal/geren_1.jpg';
import geren2 from '../../asset/img/appeal/geren_2.png';
import geren3 from '../../asset/img/appeal/geren_3.jpg';
import videoDemo from '../../asset/img/appeal/video-demo.gif';
import {rePhone} from './conf';

// import {Button, message} from 'antd';
import './appeal.less';

const PersonModal = (props) => {
    const {
        updateAppeal,
        appealData,
        fetchSendCode,
    } = props;
    const [telType, setTelType] = useState('');

    useEffect(() => {
        setTelType(rePhone.test(appealData.phone) ? 'phone' : 'tel');
    }, [appealData.phone]);

    function onSendCodeChange ({captchaTip}) {
        const recordType = window.location.pathname.indexOf('/occupy') > -1
            ? 'report-number_captcha' : 'report-mark_captcha';
        recordProxy(
            recordType,
            'click',
            captchaTip === '获取验证码' ? '获取验证码' : '重新发送'
        );
    }
    // async function nextClick() {
    //     const recordType = window.location.pathname.indexOf('/occupy') > -1
    //         ? 'report-number_submit' : 'report-mark_submit';
    //     recordProxy(
    //         recordType,
    //         appealData.phone,
    //         appealData.attributionType + ''
    //     );
    //     const errCert = telType === 'tel' ? await verifyUploadCheck(appealData.cert, 'cert') : true;
    //     const errEmail = telType === 'tel' ? await verifyCheck(appealData.email, 'email') : true;
    //     const errEmailCode = telType === 'tel' ? await verifyCheck(appealData.emailCode, 'emailCode') : true;
    //     const errPhoneCode = telType === 'phone' ? await verifyCheck(appealData.phoneCode, 'phoneCode') : true;
    //     const errIsRead = await verifyCheck(appealData.isRead, 'isRead');
    //     if (errCert && errEmail && errEmailCode && errPhoneCode && errIsRead) {
    //         // 个人
    //         let personParam = {
    //             'appeal_type': appealData.appealType,
    //             select: telType === 'phone' ? 2 : 1,
    //             label: 1, // 无此项
    //             // reason: '', // 无此项
    //             // otherReason: '', // 无此项
    //             'is_show': 0, // 开启多平台展示[无该功能]
    //             phone: appealData.phone,
    //             is_read: 1
    //         };

    //         if (telType === 'phone') {
    //             personParam = {
    //                 ...personParam,
    //                 code: appealData.phoneCode
    //             };
    //         } else {
    //             personParam = {
    //                 ...personParam,
    //                 cert_id: appealData.cert.map(item => item.id),
    //                 email: appealData.email,
    //                 code: appealData.emailCode
    //             };
    //         }
    //         const fetchAppealPersonFn = (params) => fetchAppealPerson({
    //             ...personParam,
    //             ...params
    //         }).then(data => {
    //             if (data.code === 200) {
    //                 recordProxy(
    //                     recordType + '_success',
    //                     'click',
    //                     JSON.stringify({
    //                         type: '1'
    //                     })
    //                 );
    //                 updateAppeal({
    //                     curStep: 3
    //                 });
    //                 window.scrollTo(0, 0);
    //             } else if (data.code === 401) {
    //                 Modal.warning({
    //                     title: '结果提示',
    //                     content: '当前账号已超出个人号码申诉上限，请更换账号，或添加QQ群725854778，私信管理员处理。',
    //                     okText: '知道了',
    //                     centered: true
    //                 });
    //             } else {
    //                 message.error(data.message);
    //             }
    //         });

    //         bCat_2055_request(fetchAppealPersonFn);
    //     }
    // }
    return (
        <div className="person-modal">
            {telType === 'tel' && <UploadProof
                proofType="video"
                title="证明材料"
                isMsgRequired={true}
                type="cert"
                maxImgLength={10}
                data={appealData}
                updateData={updateAppeal}
                tips={certTip()}
                demoImgs={[geren1, geren2, videoDemo]}
            />}
            {telType === 'tel' && <InputFormItem
                title="联系邮箱"
                isMsgRequired={true}
                placeholder="请输入正确的邮箱地址用来接收审核结果"
                type="email"
                data={appealData}
                updateData={updateAppeal}
                style={{width: '424px'}}
                demoImgs={[]}
            />}
            {telType === 'tel' && <SendCode
                title="邮箱验证码"
                isMsgRequired={true}
                type="emailCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.email}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>}
            {telType === 'phone' && <SendCode
                title="手机验证码"
                isMsgRequired={true}
                type="phoneCode"
                data={appealData}
                updateData={updateAppeal}
                sendData={appealData.phone}
                fetchSendCode={fetchSendCode}
                onSendCodeChange={onSendCodeChange}/>}
            {/* <AgreeProtocol
                type="isRead"
                data={appealData}
                updateData={updateAppeal} />
            <div className="btn-content">
                {!appealData.hasSearchUrl && <Button
                    className="btn-step2"
                    onClick={preClick}>上一步</Button>
                }
                <Button
                    className="btn-step2-primary"
                    type="primary"
                    disabled={!appealData.isRead}
                    onClick={nextClick}>提交</Button>
            </div> */}
        </div>
    );
};

PersonModal.propTypes = {
    updateAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchSendCode: PropTypes.func
};

export default withRouter(PersonModal);
